import {
  Box,
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
} from '@material-ui/core'
import _t, {_} from 'i18n'
import React from 'react'
import {Button, Form} from 'react-bootstrap'

import {Container, Label, Title} from './styles'

const permission = ['ROLE_ADMIN', 'ROLE_USER']

const CreateNewUser = ({formik, onFinish, customers}) => {
  const {
    handleChange,
    setFieldValue,
    values: {email, name, password, property, roles, customer},
  } = formik

  let ctype = ''
  let customer_options = []
  if (customers) {
    customers.forEach((customer) => {
      if (customer.type !== ctype) {
        ctype = customer.type
        customer_options.push(
          <ListSubheader key={`type-${customer.type}`}>
            {customer.type === 'city'
              ? _`Cidade`
              : customer.type === 'state'
              ? _`Governo`
              : customer.type === 'company'
              ? _`Company`
              : ''}
          </ListSubheader>,
        )
      }
      customer_options.push(
        <MenuItem key={customer.id} value={customer.id}>
          {customer.name}
        </MenuItem>,
      )
    })
  }

  return (
    <Container style={{padding: 0}}>
      <Box display="flex" flexDirection="column" marginBottom="40px">
        <Box marginBottom="20px">
          <Title>{_`Novo usuário`}</Title>
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Nome`}</Label>
          <Form.Control
            placeholder={_`Ex.: Example example`}
            name="name"
            onChange={handleChange}
            value={name}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Email`}</Label>
          <Form.Control
            placeholder={_`Ex.: example@example.com.br`}
            name="email"
            onChange={handleChange}
            value={email}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Senha`}</Label>
          <Form.Control
            placeholder={_`Ex.: Example`}
            name="password"
            onChange={handleChange}
            value={password}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Telefone`}</Label>
          <Form.Control
            placeholder={_`Ex.: +5541995065196`}
            name="property.phone"
            onChange={handleChange}
            value={property.phone}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Celular`}</Label>
          <Form.Control
            placeholder={_`Ex.: +5541995065196`}
            name="property.mobile_phone"
            onChange={handleChange}
            value={property.mobile_phone}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Linkedin`}</Label>
          <Form.Control
            placeholder={_`Ex.: https://perfil.no.linkedin/`}
            name="property.linkedin"
            onChange={handleChange}
            value={property.linkedin}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Facebook`}</Label>
          <Form.Control
            placeholder={_`Ex.: https://perfil.no.facebook/`}
            name="property.facebook"
            onChange={handleChange}
            value={property.facebook}
            autoComplete="off"
          />
        </Box>
        <Box display="flex" flexDirection="column" marginBottom="40px">
          <Label>{_`Cliente`}</Label>
          <FormControl color="secondary">
            <InputLabel id="customer-label">{_`Cliente`}</InputLabel>
            <Select
              labelId="customer-label"
              id="customer"
              name="customer"
              value={customer}
              onChange={handleChange}
              style={{width: '100%'}}>
              {customer_options}
            </Select>
          </FormControl>
        </Box>
        <FormControl color="secondary">
          <InputLabel id="demo-roles-label">{_`Permissões`}</InputLabel>
          <Select
            labelId="roles-label"
            id="roles"
            multiple
            value={roles}
            onChange={(e) => {
              setFieldValue('roles', e.target.value)
            }}
            input={<Input />}
            renderValue={(selected) => selected.join(', ')}
            style={{width: '100%'}}>
            {permission.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={roles.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Button type="submit" onClick={onFinish} disabled={!name}>
          {_`Cadastrar`}
        </Button>
      </Box>
    </Container>
  )
}

export default CreateNewUser
